export const IsValidEmail = (email: string) : boolean =>{
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
} 

export const IsVaidNumber = (value: string) : boolean => {
    const re = /^[0-9\b]+$/;          
    return (value.toString() === '' || re.test(value.toString()));
}